<template>
  <!-- 主页-->
  <div id="myPkHome" style="height: 100vh" v-show="showPage">
    <img src="../../assets/homeBgPk.png" width="100%" height="100%"/>
    <!--<div class="p_f t_c" style="right: 4%;bottom: 42%">-->
    <!--  <img @click="selPhone()" src="../../assets/phone.png" height="60" width="60"/>-->
    <!--  <p class="colorWhite f_w">400热线</p>-->
    <!--</div>-->
    <!--<div v-if="showPhone">-->
    <!--  <div @click="showPhone = false" class="cover" style="opacity: 1"></div>-->
    <!--  <div class="dialDiv">-->
    <!--    <div>-->
    <!--      <img src="../../assets/phone3.png" height="16" width="16"/>-->
    <!--      <a href="tel:862122306888" class="m_l_10">呼叫+86-21-2230-6888</a>-->
    <!--    </div>-->
    <!--    <div @click="showPhone = false">取消</div>-->
    <!--  </div>-->
    <!--</div>-->
    <!-- iframe -->
    <div v-if="false">
      <iframe :src="iframeUrl" frameborder="0" style="width: 100%;"></iframe>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import agreeBookDialog from "../login/agreeBookDialog";
import merge from 'webpack-merge';
export default {
  name: 'myPkHome',
  data () {
    return {
      showPage: false,
      ABDialogShow:false,
      openId: '',
      baseUrl: process.env.config.baseUrl,
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      iframeUrl: ''
    }
  },
  components: { agreeBookDialog },
  created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myPkHome?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
 }


     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }
    
    if (!localStorage.TaToken && !this.takedacode) {
      this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myPkHome?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          this.showPage = true
          // 进入主页 埋点
          this.addUserBehavior()
        })
      } else {
        this.openId = localStorage.openId
        this.showPage = true
        // 进入主页 埋点
        this.addUserBehavior()
      }
    }

      setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1000);


  },
  mounted () {
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    // 进入主页 埋点
    addUserBehavior () {
      let params = {
        openId: this.openId,
        behavior: '进入myPKFiT首页',
      }
      this.$axiox.post(`/api/Logs/AddUserBehavior`, params).then(res => {
        console.log(res, '进入myPKFiT首页 埋点')
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myPkFit/myPkHome.vue